var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import { useSiteContext } from './SiteContext';
import ResizeObserver from 'resize-observer-polyfill';
import styled from 'styled-components';
import { ViewMode } from './hooks/useSiteConfigurator';
import { useIframeMessageContext } from './IframeMessageContext';
const StyledDiv = styled.div `
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  position: relative;
  background: #f0f1f7;
  .preview-frame {
    transform-origin: top left;
  }
`;
export const PreviewFrame = (_a) => {
    var { path, children } = _a, props = __rest(_a, ["path", "children"]);
    const elementRef = useRef(null);
    // prevent updating of path after mount (rely on useSendEditPath to notify
    // iframe)
    const pathRef = useRef(path);
    // const [iframe, setIframe] = useState<HTMLIFrameElement>(null!);
    const { viewMode } = useSiteContext();
    const { setIframe } = useIframeMessageContext();
    const [size, setSize] = useState({ width: 0, height: 0 });
    // monitor resize
    useEffect(() => {
        const element = elementRef.current;
        if (element) {
            const observer = new ResizeObserver(() => {
                setSize({ width: element.clientWidth, height: element.clientHeight });
            });
            observer.observe(element);
            return () => {
                observer.unobserve(element);
            };
        }
    }, []);
    return (React.createElement(StyledDiv, { ref: elementRef, className: 'preview-container' },
        React.createElement("iframe", Object.assign({ ref: iframe => iframe && setIframe(iframe), 
            // for isIframe(), check iframe name via window.self.name
            name: 'preview-frame', title: 'preview-frame', frameBorder: 0, style: (() => {
                let scale = 1;
                let { width, height } = size;
                switch (viewMode) {
                    case ViewMode.Desktop:
                        width = 1440;
                        height = 1024;
                        break;
                    case ViewMode.Tablet:
                        width = 768;
                        height = 1024;
                        break;
                    case ViewMode.Mobile:
                        width = 375;
                        height = 812;
                        break;
                }
                scale = Math.min(size.width / width, size.height / height, 1);
                const x = (size.width - width * scale) / 2;
                const y = (size.height - height * scale) / 2;
                return {
                    width,
                    height,
                    transform: `translate(${x}px, ${y}px) scale(${scale})`
                };
            })(), src: pathRef.current, onLoad: () => {
                // if (iframe.contentWindow) {
                //   const handleUnload = () => {
                //     console.log('location', iframe.contentWindow?.location);
                //   };
                //   iframe.contentWindow.removeEventListener('pageshow', handleUnload);
                //   iframe.contentWindow.addEventListener('pageshow', handleUnload);
                // }
            } }, props))));
};
export default PreviewFrame;
//# sourceMappingURL=PreviewFrame.js.map